export class ReadNowType {
  id: number

  chapterPageId: number

  chapterId: number

  readingPercentage: number
}
